const endpoints = {
  WEBSOCKET_USER_CREATE: '/v2/websocket/me/create',
  WEBSOCKET_USER_REAUTHORIZE: '/v2/websocket/me/reAuthorize',
  GET_CONFIG: '/v2/ccp/user/getConfig',
  ENABLE_RECURRING: '/v2/ccp/user/setRecurring',
  CCP_CHARGE_FOR_PHOTO_REVEAL: '/v2/ccp/external/chargeForPhotoReveal',
  UNLOCK_MESSAGE: '/v2/ccp/external/unlockMessage',
  GET_USERS_SALES_COUNT: '/v2/ccp/user/getUserSalesCount'
}

export class User {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async authorize(opts) {
    return this.requester.post(endpoints.WEBSOCKET_USER_CREATE, {}, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async reAuthorize(opts) {
    return this.requester.get(endpoints.WEBSOCKET_USER_REAUTHORIZE, {}, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async getConfig(data = {}, opts = {}) {
    return this.requester.get(endpoints.GET_CONFIG, data, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async enableRecurring(data = {}, opts) {
    return this.requester.post(endpoints.ENABLE_RECURRING, data, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async chargeForPhotoReveal({ conversationUid, photoUrl }, opts = {}) {
    return this.requester.post(endpoints.CCP_CHARGE_FOR_PHOTO_REVEAL, { conversationUid, photoUrl }, opts)
  }

  async unlockMessage({ messageId }, opts = {}) {
    return this.requester.post(endpoints.UNLOCK_MESSAGE, { messageId }, opts)
  }

  async getUserSalesCount(data = {}, opts = {}) {
    return this.requester.get(endpoints.GET_USERS_SALES_COUNT, data, { ...opts})
  }
}
